module.exports = __webpack_public_path__ + "static/media/heroBg.10978fa4.jpg";